import type { ColumnsType } from 'antd/es/table';
import { TFunction, i18n as I18nType } from 'i18next';
import withLoadingSkeleton from '@/HOCs/withLoadingSkeleton';
import { VoteResultByShareholderType } from '../types';
import { Tooltip } from 'antd';

export const voteResultsByShareholderColumns = ({
  isLoading,
  t,
  data,
  i18n,
}: {
  isLoading: boolean;
  t: TFunction<'plans'>;
  data: VoteResultByShareholderType[];
  i18n: I18nType;
}): ColumnsType<VoteResultByShareholderType> => [
  {
    title: t('name'),
    dataIndex: 'name',
    sorter: true,
    width: '10%',
    fixed: i18n.language === 'en' ? 'left' : 'right',
    render: withLoadingSkeleton(isLoading, (val: string) => val),
  },
  ...(Object.keys(data[0])
    .filter((key) => key !== 'id' && key !== 'name' && key !== 'total_shares' && key !== 'ownership')
    .map((key) => ({
      title: <Tooltip title={data[0][key].point_description}>{key}</Tooltip>,
      dataIndex: key,
      render: withLoadingSkeleton(isLoading, (_, record?: VoteResultByShareholderType) => {
        const cell = record?.[key as keyof VoteResultByShareholderType] as { value: string | null } | undefined;
        return t(cell?.value ?? 'no vote');
      }),
    })) as ColumnsType<VoteResultByShareholderType>),
];
